var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view'),_c('footer-comp')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('noscript',[_c('iframe',{staticStyle:{"display":"none","visibility":"hidden"},attrs:{"src":"https://www.googletagmanager.com/ns.html?id=GTM-P5X653C","height":"0","width":"0"}})])
}]

export { render, staticRenderFns }